var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 876 764",
    style: {
      enableBackground: "new 0 0 876 764"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#06ADBF;}\n\t.st1{fill:#FAFBFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 398.12,
    cy: 386,
    r: 320
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M517.31,248c-10.39,0-18.82,8.43-18.82,18.82v15.77l-200.73,53.13v-15.59c0-10.39-8.43-18.82-18.82-18.82 s-18.82,8.43-18.82,18.82v131.73c0,10.39,8.43,18.82,18.82,18.82s18.82-8.43,18.82-18.82v-12.45l11.11,2.94 c-0.59,2.69-0.92,5.47-0.92,8.34c0,21.44,17.38,38.81,38.81,38.81c17.43,0,32.17-11.49,37.08-27.3l114.65,30.35v12.64 c0,10.39,8.43,18.82,18.82,18.82c10.39,0,18.82-8.43,18.82-18.82V266.82C536.12,256.43,527.7,248,517.31,248z M346.77,471.31 c-11.39,0-20.62-9.23-20.62-20.62c0-1.26,0.15-2.47,0.37-3.67l39.62,10.49C363.31,465.53,355.75,471.31,346.77,471.31z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon-notice.72a5c9639075effd3218359fde298fd8.svg";
export { ForwardRef as ReactComponent };